import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './FreemanRegistration.css';
import LanguageSelection from './LanguageSelection';
import LoginSection from './LoginSection';
import WelcomeText from './WelcomeText';
import { updateWorkmanProfile } from '../../../../services/selfOnboarding';

const FreemanRegistration = ({ isLoginScreen = true, setShowLanguageSelectionSection }) => {
  const { id } = useParams();
  const { i18n } = useTranslation();

  const handleLanguageSelect = async (language) => {
    i18n.changeLanguage(language);
    // api call to save user preference
    await updateWorkmanProfile({ 
      updateLanguagePreference: true, 
      workmanId: id, 
      preferredLanguage: language
    });
    setShowLanguageSelectionSection(false);
  };

  return (
    <div className="freeman-container">
      <div className={isLoginScreen ? "content-wrapper-ellipse" : "content-wrapper"}>
        <WelcomeText />

        {!isLoginScreen && <LanguageSelection onLanguageSelect={handleLanguageSelect} />}
      </div>
      {isLoginScreen && <LoginSection />}

    </div>
  );
};

export default FreemanRegistration ;